import {DisplayEvent} from "../../../infrastructure/models/analytics/display-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class GameStatsWidgetActualPlayTimeDisplayEvent extends DisplayEvent {
  gameId: Number;
  status: Number;
  sportTypeId: Number;

  constructor(params) {
    super('actual-time');

    this.gameId = params.gameId;
    this.status = params.status;
    this.sportTypeId = params.sportTypeId
  }

  get properties(): Object {
    const properties = super.properties;

    properties.gameId = this.gameId;
    properties.status = ANALYTICS.GAME_STATUSES[this.status];
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }

  get isPopulated(): Boolean {
    let isPopulated = super.isPopulated;

    isPopulated &= !!this.gameId;
    isPopulated &= !!this.status;
    isPopulated &= !!this.sportTypeId;

    return isPopulated;
  }
}
